<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionExitModal.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>{{ $t('mEditionExitModal.message') }}</p>
      </section>
      <footer class="m-the-modal-footer">
        <button
          :class="buttonPrimary.cancel.class"
          :type="buttonPrimary.type"
          @click="cancelAction"
        >
          {{ $t('mEditionExitModal.buttonCancel') }}
        </button>
        <button
          :class="buttonPrimary.goBack.class"
          :type="buttonPrimary.type"
          @click="confirmAction"
        >
          {{ $t('mEditionExitModal.buttonPrimary') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionExitModal',

  data () {
    return {
      buttonPrimary: {
        cancel: {
          class: 'a-button-the-modal-cancel-action',
          type: 'button'
        },

        goBack: {
          class: 'a-button-primary a-button-billing-primary',
          type: 'button'
        }
      },

      route: ''
    }
  },

  created () {
    this.route = this.$store.getters.getExitEditionRoute
  },

  methods: {
    cancelAction (event) {
      event.preventDefault()
      this.$modal.closeModal()
      this.$store.commit('setExitEditionRoute', ({}))
      this.$store.commit('setExitEdition', (false))
      this.$router.push(`${this.route.to.path}`)
    },

    confirmAction (event) {
      event.preventDefault()
      this.$modal.closeModal()
    }
  }
}
</script>
